import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Form, Input, InputNumber, Select, Icon, Switch, Tooltip, notification } from "antd";
import moment from "moment";
import axios from "axios";

import { useFiltros } from "../FiltrosContext";
import { GlobalContext } from "../../../../app/providers/GlobalState";

const { Option } = Select;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const FormTurma = ({ categorias, onClose, form }) => {
    const [registo, setRegisto] = useState({
        nomeTurma: "",
        categoriaId: undefined,
        turnoId: undefined,
        codigo: "",
        calendarioId: undefined,
        professorTitularId: undefined
    });
    const [turnos, setTurnos] = useState([]);
    const [calendarios, setCalendarios] = useState([]);
    const [coordenadores, setCoordenadores] = useState([]);
    const [coordenadoresSelecionados, setCoordenadoresSelecionados] = useState([]);
    const [coordenadoresStatusField, setCoordenadoresStatusField] = useState({
        validateStatus: "",
        help: ""
    });
    const [professores, setProfessores] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const { turmaId, setDrawerVisivel, triggerRefresh } = useFiltros();

    const globalContext = useContext(GlobalContext);

    const { getFieldDecorator } = form;

    const handleSubmit = e => {
        e.preventDefault();

        if (!coordenadoresSelecionados.length) {
            setCoordenadoresStatusField({
                validateStatus: "error",
                help: "Deve adicionar pelo menos um coordenador"
            });
            return;
        }

        form.validateFields((err, values) => {
            if (!err) {
                setIsLoading(true);

                if (turmaId) alterarTurma(values);
                else criarTurma(values);
            }
        });
    };

    const carregarTurma = turmaId => {
        axios({
            method: "get",
            url: "/api/gestao-turmas/carregar-turma-ensino-especial",
            params: {
                turmaId
            }
        })
            .then(response => {
                const { nomeTurma, categoriaId, turnoId, codigo, calendarioId, professorTitularId, coordenadores } = response.data;

                setRegisto({
                    nomeTurma,
                    categoriaId,
                    turnoId,
                    codigo,
                    calendarioId,
                    professorTitularId
                });

                const coordenadoresFormatados = coordenadores.map(c => ({
                    id: c.id,
                    nome: c.nome,
                    carga_horaria: c.cargaHoraria,
                    replicar: c.replicar
                }));

                setCoordenadoresSelecionados(coordenadoresFormatados);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Ocorreu um erro!");
            });
    };

    const criarTurma = values => {
        var item = new FormData();
        item.append("id_organismo", globalContext?.estabelecimento?.id);
        item.append("turma", values.nomeTurma);
        item.append("id_turma_categoria", values.categoriaId);
        if (values.turnoId) item.append("id_turno", values.turnoId);
        item.append("codigo", values.codigo);
        item.append("id_calendario", values.calendarioId);
        item.append("coordenadores", JSON.stringify(values.coordenadores));

        axios({
            method: "post",
            url: "/api/gestao-turmas/adicionar-ensino-especial",
            data: item
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Adicionada nova turma de educação especial!");
            })
            .catch(error => {
                try {
                    openNotificationWithIcon("error", "Erro", error.response.data);
                } catch (error) {
                    openNotificationWithIcon("error", "Erro", "Ocorreu um erro!");
                }
            })
            .finally(() => {
                setIsLoading(false);
                setDrawerVisivel(false);
                triggerRefresh();
            });
    };

    const alterarTurma = values => {
        var item = new FormData();
        item.append("id", turmaId);
        item.append("id_organismo", globalContext?.estabelecimento?.id);
        item.append("turma", values.nomeTurma);
        item.append("id_turma_categoria", values.categoriaId);
        if (values.turnoId) item.append("id_turno", values.turnoId);
        item.append("codigo", values.codigo);
        item.append("id_calendario", values.calendarioId);
        item.append("coordenadores", JSON.stringify(values.coordenadores));
        if (values.professorTitularId) item.append("id_prof_titular", values.professorTitularId);

        axios({
            method: "put",
            url: "/api/gestao-turmas/alterar-ensino-especial",
            data: item
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Turma de educação especial editada!");
            })
            .catch(error => {
                try {
                    openNotificationWithIcon("error", "Erro", error.response.data);
                } catch (error) {
                    openNotificationWithIcon("error", "Erro", "Ocorreu um erro!");
                }
            })
            .finally(() => {
                setIsLoading(false);
                setDrawerVisivel(false);
                triggerRefresh();
            });
    };

    const carregarTurnos = () => {
        axios({
            method: "get",
            url: "/api/gestao-turmas/lista-turnos"
        })
            .then(response => {
                setTurnos(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os turnos");
            });
    };

    const carregarCalendarios = () => {
        axios({
            method: "get",
            url: "/api/gestao-turmas/lista-calendarios",
            params: {
                cursoId: turmaId
            }
        })
            .then(response => {
                setCalendarios(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os calendários");
            });
    };

    const carregarCoordenadores = () => {
        axios({
            method: "get",
            url: "/api/gestao-turmas/carregar-formadores",
            params: {
                escolaId: globalContext?.estabelecimento?.id,
                perfilId: 5
            }
        })
            .then(response => {
                setCoordenadores(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar coordenadores!");
            });
    };

    const adicionarCoordenadores = () => {
        const coordenador = {
            id: undefined
        };

        setCoordenadoresSelecionados([...coordenadoresSelecionados, coordenador]);
        setCoordenadoresStatusField({
            validateStatus: "",
            help: ""
        });
    };

    const montarCoordenadores = coordenadorId => {
        let coordenadoresIds = coordenadoresSelecionados.map(c => c.id);
        if (coordenadorId) coordenadoresIds = coordenadoresIds.filter(id => id !== coordenadorId);

        const modoEditar = false; //(cursoid > 0 && visible) || (disciplinaid > 0 && visibleDisciplina);
        const userExcluido = coordenadores.some(c => c.id === coordenadorId && c.excluido);

        return coordenadores.filter(
            c =>
                !coordenadoresIds.includes(c.id) &&
                (!modoEditar ? !c.excluido : userExcluido ? !c.excluido || c.id === coordenadorId : !c.excluido)
        );
    };

    const excluirCoordenador = index => {
        const novaLista = [...coordenadores];
        novaLista.splice(index, 1);
        setCoordenadores(novaLista);
    };

    useEffect(() => {
        carregarTurnos();
        carregarCalendarios();
        carregarCoordenadores();

        if (turmaId) carregarTurma(turmaId);
    }, [turmaId]);

    let calendarioInfo = "";
    if (registo.calendarioId) {
        const calendario = calendarios.find(x => x.id === registo.calendarioId);
        if (calendario)
            calendarioInfo = (
                <div style={{ borderTop: "1px solid #d9d9d9", marginTop: 10 }}>
                    <span>
                        {moment(calendario.dt_inicio).format("DD/MM/YYYY")} - {moment(calendario.dt_termino).format("DD/MM/YYYY")}
                    </span>
                    <span style={{ fontSize: 13, color: "#16817a", display: "block", lineHeight: "initial" }}>
                        {JSON.parse(calendario.tipo).join(", ")}
                    </span>
                </div>
            );
    }

    return (
        <div className="bloco-info">
            <Form className="form-add-curso" layout="horizontal" onSubmit={handleSubmit}>
                <Form.Item label="Turma">
                    {getFieldDecorator("nomeTurma", {
                        initialValue: registo.nomeTurma,
                        rules: [
                            {
                                required: true,
                                message: "Campo obrigatório"
                            }
                        ]
                    })(<Input name="nomeTurma" />)}
                </Form.Item>
                <Form.Item label="Nível">
                    {getFieldDecorator("categoriaId", {
                        initialValue: registo.categoriaId,
                        rules: [
                            {
                                required: true,
                                message: "Campo obrigatório"
                            }
                        ]
                    })(
                        <Select placeholder="Selecionar" allowClear={true}>
                            {categorias.map(categoria => (
                                <Option key={categoria.id} value={categoria.id}>
                                    {categoria.nome}
                                </Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="Turno">
                    {getFieldDecorator("turnoId", {
                        initialValue: registo.turnoId
                    })(
                        <Select placeholder="Selecionar" allowClear={true}>
                            {turnos.map(turno => (
                                <Option key={turno.id} value={turno.id}>
                                    {turno.nome}
                                </Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="Código">
                    {getFieldDecorator("codigo", {
                        initialValue: registo.codigo,
                        rules: [
                            {
                                required: true,
                                message: "Campo obrigatório"
                            }
                        ]
                    })(<Input name="codigo" />)}
                </Form.Item>
                <Form.Item label="Calendário">
                    {getFieldDecorator("calendarioId", {
                        initialValue: registo.calendarioId,
                        rules: [
                            {
                                required: true,
                                message: "Campo obrigatório"
                            }
                        ]
                    })(
                        <Select
                            placeholder="Selecionar"
                            allowClear={true}
                            onChange={value => setRegisto({ ...registo, calendarioId: value })}
                        >
                            {calendarios.map(calendario => (
                                <Option key={calendario.id} value={calendario.id}>
                                    {calendario.nome}
                                </Option>
                            ))}
                        </Select>
                    )}
                    {calendarioInfo}
                </Form.Item>
                <Form.Item validateStatus={coordenadoresStatusField.validateStatus} help={coordenadoresStatusField.help}>
                    <div className="bloco-fases-escolares">
                        <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                            Coordenador(es) / Carga horaria da coordenação
                            <button className="botao-principal" type="button" onClick={adicionarCoordenadores}>
                                <Icon type="plus" />
                            </button>
                        </h3>
                        <div className="curso-lista-fases">
                            {!coordenadoresSelecionados.length ? <span>Sem dados</span> : null}
                            {coordenadoresSelecionados.map((coordenador, index) => (
                                <div key={index} className="item">
                                    <div className="item-inputs">
                                        <Form.Item>
                                            {getFieldDecorator(`coordenadores[${index}].id`, {
                                                initialValue: coordenador.id,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Campo obrigatório"
                                                    }
                                                ]
                                            })(
                                                <Select
                                                    showSearch
                                                    placeholder="Selecionar"
                                                    optionFilterProp="children"
                                                    onFocus={() => {}}
                                                    onBlur={() => {}}
                                                    onSearch={() => {}}
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {montarCoordenadores(coordenador.id).map(coordenador => (
                                                        <Option key={coordenador.id} value={coordenador.id}>
                                                            {coordenador.nome}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                        <Form.Item>
                                            {getFieldDecorator(`coordenadores[${index}].carga_horaria`, {
                                                initialValue: coordenador.carga_horaria,
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: "Campo obrigatório"
                                                    }
                                                ]
                                            })(<InputNumber name={`coordenadores${index}.carga_horaria`} min={0} />)}
                                        </Form.Item>
                                        <Form.Item>
                                            <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                {getFieldDecorator(`coordenadores[${index}].replicar`, {
                                                    initialValue: coordenador.replicar,
                                                    valuePropName: "checked"
                                                })(<Switch size="small" />)}
                                                Replicar nos alunos
                                                <Tooltip
                                                    className="info-icon"
                                                    title="O coordenador é replicado apenas na criação de uma nova disciplina."
                                                >
                                                    <Icon type="question-circle-o" />
                                                </Tooltip>
                                            </span>
                                        </Form.Item>
                                    </div>
                                    <Link className="botao-icon-excluir" to="#" title="Excluir" onClick={() => excluirCoordenador(index)}>
                                        <Icon type="delete" />
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </Form.Item>
                {turmaId && (
                    <Form.Item label="Professor Titular">
                        {getFieldDecorator("professorTitularId", {
                            initialValue: registo.professorTitularId
                        })(
                            <>
                                <Select placeholder="Selecionar" allowClear={true}>
                                    {professores.map(professor => (
                                        <Option key={professor.id} value={professor.id}>
                                            {professor.nome}
                                        </Option>
                                    ))}
                                </Select>
                            </>
                        )}
                    </Form.Item>
                )}
                <div className="ant-drawer-footer">
                    <button
                        className="botao-secundario"
                        type="button"
                        onClick={onClose}
                        style={{ marginRight: 20, display: "inline-block" }}
                    >
                        Voltar
                    </button>
                    <button className="botao-principal" type="submit" disabled={isLoading}>
                        {isLoading ? <Icon type="loading" /> : null}
                        Salvar
                    </button>
                </div>
            </Form>
        </div>
    );
};

export default Form.create({ name: "form-turma" })(FormTurma);
